import React, { useState, useEffect } from "react";
import { Table, Modal, Button } from "react-bootstrap";
import IconButton from "@mui/material/IconButton";
import Swal from "sweetalert2";
import Hexapi from "../usefulcomps/HexAPI/Hexapi";
import AssignmentIcon from "@mui/icons-material/Assignment";
import Tooltip from "@mui/material/Tooltip";
import MoneyReceiptForm from "./MoneyReceiptForm";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";

function MoneyReceiptLog(props) {
  const [modalLoading, setModalLoading] = useState(true);
  const [MoneyReceiptRowdata, SetMoneyReceiptRowdata] = useState([]);
  const [MoneyReceiptHeaders, setMoneyReceiptHeaders] = useState([]);
  const [AddMoneyReceiptDisable, setAddMoneyReceiptDisable] = useState(false);
  const fetchRowDetails = async () => {
    setModalLoading(true);
    let obj = {
      query: `[dbo].[CRM_Proc_MoneyReceipt_GetList] @agentID='{0}', @EnquiryID='{1}'`,
      queryArr: [`${props.AgentID}`, `${props.enquiryID}`],
    };
    try {
      const resp = await Hexapi(obj);
      console.log("Row details:", resp);

      // ✅ Always set disable flag regardless of row count
      setAddMoneyReceiptDisable(
        Number(resp["config"]?.[0]?.["adddisable"]) === 1,
      );

      if (resp[""].length > 0) {
        SetMoneyReceiptRowdata(resp[""]);
        setMoneyReceiptHeaders(Object.keys(resp[""][0]));
      } else {
        SetMoneyReceiptRowdata([]);
        setMoneyReceiptHeaders([]);
      }
    } catch (err) {
      console.error("Error fetching row details:", err);
    } finally {
      setModalLoading(false);
    }
  };
  useEffect(() => {
    if (props.isOpen) {
      fetchRowDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isOpen]);

  const renderCell = (col, row, rowIndex) => {
    // Default cell rendering
    const value = row[col];
    let displayValue = "";

    if (value && typeof value === "object" && value.date) {
      displayValue = new Date(value.date).toLocaleDateString("en-IN");
    } else if (value instanceof Date) {
      displayValue = value.toLocaleDateString("en-IN");
    } else {
      displayValue = String(value ?? "");
    }

    return (
      <td key={col} style={{ textAlign: "center" }}>
        {displayValue}
      </td>
    );
  };

  return (
    <>
      <Tooltip title="Money Receipt">
        <AccountBalanceWalletIcon
          style={{ cursor: "pointer", fontSize: "25px" }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            props.onOpen?.();
          }}
        />
      </Tooltip>

      <Modal
        show={props.isOpen}
        onHide={() => props.onClose?.()}
        dialogClassName="custom-modal"
        scrollable
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header style={{ backgroundColor: "#f5f9ff" }}>
          <div className="w-100">
            <div>
              <strong>Money Receipt Log</strong>
            </div>
            <div className="d-flex gap-4 mt-2">
              <span>
                <strong>EnquiryID:</strong> {props.enquiryID}
              </span>
              <span>
                <strong>CustomerName:</strong> {props.customerName}
              </span>
            </div>
          </div>
          <div className="d-flex align-items-center">
            {!modalLoading && (
              <div style={{ cursor: "pointer", marginRight: "10px" }}>
                <MoneyReceiptForm
                  AgentID={props.AgentID}
                  enquiryID={props.enquiryID}
                  customerName={props.customerName}
                  RefreshLogs={() => fetchRowDetails()}
                  disabled={AddMoneyReceiptDisable}
                />
              </div>
            )}
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={() => props.onClose?.()}
            />
          </div>
        </Modal.Header>

        <Modal.Body style={{ maxHeight: "85vh", overflowY: "auto" }}>
          {!modalLoading ? (
            MoneyReceiptRowdata.length > 0 ? (
              <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                <Table
                  striped
                  className="custom-table w-100"
                  size="sm"
                  style={{ borderCollapse: "collapse" }}
                >
                  <thead>
                    <tr>
                      {MoneyReceiptHeaders.map((s, index) => (
                        <th
                          key={index}
                          style={{
                            background: "#000",
                            color: "white",
                            position: "sticky",
                            top: 0,
                            zIndex: 2,
                            whiteSpace: "nowrap",
                            textAlign: "center",
                          }}
                        >
                          {s.toUpperCase()}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody style={{ whiteSpace: "nowrap", cursor: "pointer" }}>
                    {MoneyReceiptRowdata.map((row, rowIndex) => (
                      <tr key={rowIndex}>
                        {MoneyReceiptHeaders.map((col) =>
                          renderCell(col, row, rowIndex),
                        )}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            ) : (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ minHeight: "200px" }}
              >
                <span>No Records!</span>
              </div>
            )
          ) : (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: "200px" }}
            >
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default MoneyReceiptLog;
